module.exports = __webpack_public_path__ + "img/sintesis.d6358478.png";